import { render, staticRenderFns } from "./popup-tui-liao.vue?vue&type=template&id=616b0470&scoped=true"
import script from "./popup-tui-liao.vue?vue&type=script&lang=js"
export * from "./popup-tui-liao.vue?vue&type=script&lang=js"
import style0 from "./popup-tui-liao.vue?vue&type=style&index=0&id=616b0470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b0470",
  null
  
)

export default component.exports